<div class="container-login-page">
  <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxFlex>
    <div fxFlex fxLayoutAlign="center center">
      <img width="31%" src="../assets/images/logo-pag-verde.svg">
    </div>
    <div fxFlex>
      <div fxLayout="row" fxLayoutAlign="center center" class="content-div">
        <div class="flex-me">
          <mat-card>
            Redirecionando para <b style="color: #FF8B22;">Login SSO</b> ...
            <mat-card-actions class="group-buttons">
              <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
            </mat-card-actions>
          </mat-card>
          <div fxLayoutAlign="center center">
            <img class="image imagem-rodape" src="../assets/images/logo_mrv_principal_rgb.png">
          </div>
        </div>
        <div class="loadingg">
          <span *ngIf="loading"><mat-spinner></mat-spinner></span>
        </div>
      </div>
    </div>
  </div>
</div>